var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/ExportEnums';
let DefineCurrentVersionModule = class DefineCurrentVersionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.listExportProfit = [];
        this.listBudgetType = [];
        this.status = '';
        this.statusMessage = '';
        this.listVersion = [];
        this.checkedListProfitCenter = [];
    }
    get getLoadingExport() {
        return this.loading;
    }
    get getListExportProfit() {
        return this.listExportProfit;
    }
    get getListBudgetType() {
        return this.listBudgetType;
    }
    get getExportListVersion() {
        return this.listVersion;
    }
    get getCheckedListProfitCenter() {
        return this.checkedListProfitCenter;
    }
    [_a = Mutations.SET_EXPORT_LOADING]() {
        this.loading = !this.loading;
    }
    [_b = Mutations.SET_EXPORT_PROFIT_CENTER](payload) {
        this.listExportProfit = payload;
    }
    [_c = Mutations.SET_EXPORT_BUDGET_TYPE](payload) {
        this.listBudgetType = payload;
    }
    [_d = Mutations.SET_CHECKED_PROFIT_CENTER](payload) {
        this.checkedListProfitCenter = payload;
    }
    [_e = Mutations.SET_EXPORT_VERSION](payload) {
        this.listVersion = payload;
    }
    [_f = Actions.GET_EXPORT_PROFIT_CENTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/profitcenterfilter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: '1',
                Size: '999999',
                Desc: '',
                profitCenter: []
            };
            const dataProfitCenter = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _m;
                    if (res.status === 200) {
                        (_m = res.data.result.content) === null || _m === void 0 ? void 0 : _m.data.map((data) => {
                            if (dataProfitCenter.length === 0) {
                                dataProfitCenter.push({
                                    value: data.profitCenter,
                                    label: data.profitCenter
                                });
                            }
                            else {
                                const findId = dataProfitCenter.find((element) => {
                                    return element.value === data.profitCenter;
                                });
                                if (findId === undefined) {
                                    dataProfitCenter.push({
                                        value: data.profitCenter,
                                        label: data.profitCenter
                                    });
                                }
                            }
                        });
                        this.context.commit(Mutations.SET_EXPORT_PROFIT_CENTER, dataProfitCenter);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_g = Actions.GET_EXPORT_BUDGET_TYPE]() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgettype/lookup?` +
                new URLSearchParams(params).toString();
            const dataBudgetType = [];
            return new Promise((resolve, reject) => {
                ApiService.get(url, '')
                    .then((res) => {
                    if (res.status === 200) {
                        res.data.result.content.map((data) => {
                            dataBudgetType.push({
                                value: data.budgetTypeID,
                                label: data.budgetTypeDesc
                            });
                        });
                        this.context.commit(Mutations.SET_EXPORT_BUDGET_TYPE, dataBudgetType);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_h = Actions.CREATE_EXPORT_BUDGET_TYPE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/export/summaryreconcile?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                budgetType: data.budgetType.toString(),
                exportBy: data.exportBy,
                summaryBy: data.summaryBy,
                periodFrom: data.periodFrom,
                periodTo: data.periodTo,
                profitCenter: data.profitCenter,
                version: data.version
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    const listDownload = JSON.parse(localStorage.getItem('exportFile') || '[]');
                    const found = listDownload.find((e) => {
                        return e == res.data.result.content;
                    });
                    if (!found) {
                        const dummyListDownload = [...listDownload, res.data.result.content];
                        localStorage.setItem('exportFile', JSON.stringify(dummyListDownload));
                    }
                    resolve(res);
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_j = Actions.GET_EXPORT_VERSION](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/currentversion/lookup?ver=v1`;
            const dataVersion = [];
            return new Promise((resolve, reject) => {
                ApiService.post(url, data)
                    .then((res) => {
                    var _m;
                    if (res) {
                        (_m = res.data.result.content) === null || _m === void 0 ? void 0 : _m.map((data) => {
                            dataVersion.push({
                                value: data.version,
                                label: data.version
                            });
                        });
                        this.context.commit(Mutations.SET_EXPORT_VERSION, dataVersion);
                        resolve(res);
                    }
                    else {
                        reject(false);
                    }
                    return res;
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_k = Actions.GET_EXPORT_STATUS_FILE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/file/${data}?ver=v1`;
            return new Promise((resolve, reject) => {
                ApiService.get(url, '')
                    .then((res) => {
                    if (res.data.result.content.status === 'Completed') {
                        const dummyData = JSON.parse(localStorage.getItem('exportFile') || '[]');
                        const index = dummyData.indexOf(data);
                        dummyData.splice(index, 1);
                        localStorage.setItem('exportFile', JSON.stringify(dummyData));
                        this.context.dispatch(Actions.GET_EXPORT_FILE, res.data.result.content.url);
                    }
                    resolve(res);
                })
                    .catch(() => {
                    reject(false);
                });
            });
        });
    }
    [_l = Actions.GET_EXPORT_FILE](url) {
        return __awaiter(this, void 0, void 0, function* () {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'downloadexport.xlsx'); // or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DefineCurrentVersionModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DefineCurrentVersionModule.prototype, _l, null);
DefineCurrentVersionModule = __decorate([
    Module
], DefineCurrentVersionModule);
export default DefineCurrentVersionModule;
